"use client";

import React from "react";
import { styled } from "styled-components";
import { DepartmentDTO } from "@/data/bruktbilsalgBackend/types/department.types";
import { CarInformation } from "./carInformation";
import { Car } from "@/data/bruktbilsalgBackend/types/car.types";
import { DealerInformation } from "./DealerInformation";
import { breakpointDesktop } from "@gnist/design-system";
import { tokens } from "@gnist/themes/tokens.css.js";

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${breakpointDesktop}) {
    flex-direction: row;
    column-gap: calc(2 * ${tokens.spacing.xl});
  }
`;

interface Props {
  car: Car;
  dealer: DepartmentDTO;
  departmentSlug?: string;
}

export const CarPageContent = ({ car, dealer, departmentSlug }: Props) => {
  return (
    <ContentWrapper>
      <CarInformation car={car} departmentSlug={departmentSlug} />
      <DealerInformation dealer={dealer} departmentSlug={departmentSlug} />
    </ContentWrapper>
  );
};
